(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const initStrips = () => {
      document.querySelectorAll('media-gallery').forEach((gallery) => {
        const component = gallery.querySelector('slideshow-component');
        if (!component || component.querySelector('.baugeste-gallery-strip')) return;

        const slides = component.querySelectorAll('slideshow-slide');
        const count = slides.length;
        if (count <= 1) return;

        let scroller = component.querySelector('slideshow-slides');
        if (!scroller) {
          scroller = Array.from(component.querySelectorAll('*')).find((el) => {
            const style = getComputedStyle(el);
            return el.scrollWidth > el.clientWidth + 10 && style.overflowX !== 'visible';
          });
        }
        if (!scroller) return;

        const strip = document.createElement('div');
        strip.className = 'baugeste-gallery-strip';
        strip.style.setProperty('--strip-count', count);
        strip.setAttribute('aria-hidden', 'true');

        const segment = document.createElement('div');
        segment.className = 'baugeste-gallery-strip__segment';
        strip.appendChild(segment);
        component.appendChild(strip);

        let raf = null;
        const update = () => {
          raf = null;
          const max = scroller.scrollWidth - scroller.clientWidth;
          const progress = max > 0 ? scroller.scrollLeft / max : 0;
          segment.style.transform = `translateX(${progress * (count - 1) * 100}%)`;
        };

        scroller.addEventListener(
          'scroll',
          () => {
            if (raf === null) raf = requestAnimationFrame(update);
          },
          { passive: true }
        );
        update();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStrips);
    } else {
      initStrips();
    }
    document.addEventListener('shopify:section:load', initStrips);
  })();
  } catch(e) { console.error(e); }
})();

})();
